import { Loader2 } from 'lucide-react';

export default function Loader({ size = "lg", text = "Creating your workspace..." }) {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-14 h-14",
    lg: "w-20 h-20"
  };

  return (
    <div className="fixed inset-0 bg-zinc-950/80 backdrop-blur-md z-50 flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="relative">
          <Loader2 className={`animate-spin text-violet-600 ${sizeClasses[size]}`} />
          <div className="absolute inset-0 bg-violet-600/20 rounded-full blur-xl animate-pulse" />
        </div>
        
        {text && (
          <p className="text-zinc-400 text-lg font-medium tracking-wide">
            {text}
          </p>
        )}
      </div>
    </div>
  );
}